import styles from "../../styles/sheet-upload.module.scss";
import { useState } from "react";
import { Upload } from "./Icons";

import classNames from "classnames/bind";
import { Button } from "./Button";
const css = classNames.bind(styles);

export const FileReaderInput = ({ onFileLoaded, acceptedTypes, file }) => {
  const [hasNewFile, setHasNewFile] = useState(false);

  const acceptedTypesDescription = acceptedTypes.join(", ");

  const handleSetFile = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const extension = `.${file.name.split(".").pop()?.toLowerCase()}`;

    if (!acceptedTypes.includes(extension)) {
      console.log({
        acceptedTypes,
        extension,
      });
      alert({
        text: "Tipo do arquivo inválido",
      });
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (readerEvent) => {
      const readResult = readerEvent.target?.result;

      const base64Data = readResult?.split(",")[1];

      if (typeof base64Data === "string") {
        onFileLoaded({
          name: file.name,
          content: base64Data,
        });

        setHasNewFile(true);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <>
      <label htmlFor="upload" className={css({ upload: true, hasNewFile })}>
        <div className={styles.icon}>
          <Upload color={hasNewFile ? "#6161ff" : "#4C4C4C"} />
        </div>

        <div className={styles.selectFile}>
          <p>{hasNewFile || file ? "Carregar outro arquivo" : "Clique aqui"}</p>
          {!file && <span>para fazer upload de arquivos</span>}
        </div>

        {file && <span className={styles.fileAccepted}>{file.name}</span>}

        <span className={styles.fileAccepted}>
          Tipo do arquivo aceito: {acceptedTypesDescription}
        </span>

        <input
          type="file"
          id="upload"
          accept={acceptedTypesDescription}
          onChange={(e) => handleSetFile(e)}
        />
      </label>
    </>
  );
};
